module.exports = __webpack_public_path__ + "img/Creativity-on@3x.e78541a1.png";